import $ from "jquery";
import "slick-carousel-latest";
// import "daterangepicker";

import "./js/login";
import "./js/agenda-api";
import "./js/contact-map";
import "./js/netwerk-map";
import "./js/header";
import "./js/pages";
import "./js/misc";
import "./js/modal";
import "./js/profile";
import "./js/register-event";
// import "./js/daterange";
import "./js/tagsDropdown";
import "./js/register";
import "./js/forgot-password";


jQuery(function () {



  // Smooth scrolling to anchor # ///////////////////////////////////////////////////
  // ////////////////////////////////////////////////////////////////////////////////
  $('a[href*="#"]:not([href="#"]):not(.sf-dump-toggle)').on(
    "click",
    function () {
      if (
        location.pathname.replace(/^\//, "") ==
        this.pathname.replace(/^\//, "") &&
        location.hostname == this.hostname
      ) {
        var target = $(this.hash);
        target = target.length
          ? target
          : $("[name=" + this.hash.slice(1) + "]");
        if (target.length) {
          $("html,body").animate(
            {
              scrollTop: target.offset().top,
            },
            1000
          );

          target.trigger("focus");
          return false;
        }
      }
    }
  );
  // Smooth scrolling to anchor # ///////////////////////////////////////////////////
  // //////////////////////////////////////////////////////////////////////////// END
});
// Document.ready END
///////////////////////////////////////////////////////////////////////////////
